import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BlobType, ErrorNotificationMode, FileModel } from '@ca/core/models';
import { FileUploadService } from '@ca/core/services';
import { Guid } from 'guid-typescript';
import { FileUploader } from 'ng2-file-upload';
import { SUPPORTED_IMAGE_TYPES } from '../../constants/form-validators';

@Component({
    selector: 'ca-files-upload-button',
    templateUrl: './files-upload-button.component.html',
    styleUrls: ['./files-upload-button.component.scss'],
})
export class FilesUploadButtonComponent implements OnInit, AfterViewInit {
    @Input() buttonText: string;
    @Input() pathToAppend: string;
    @Input() blobType: BlobType = BlobType.UserFile;
    @Input() maxFileSizeInBytes: number = 10 * 1024 * 1024;
    @Input() supportedImageTypes: string[] = SUPPORTED_IMAGE_TYPES;
    @Input() accept: string = 'image/*';
    @Input() multiple: boolean = false;
    @Input() errorNotificationMode: ErrorNotificationMode;

    isUploading: boolean = false;
    formGroup: UntypedFormGroup;
    uploader: FileUploader | null;
    file: FileModel | null = null;

    readonly uploaderKey = 'file-uploader';

    get fileUrls(): UntypedFormArray {
        return this.formGroup.get('fileUrls') as UntypedFormArray;
    }

    constructor(
        private formBuilder: UntypedFormBuilder,
        private fileUploadService: FileUploadService,
    ) {}

    onUploadStarted(): void {
        this.isUploading = true;
    }

    onUploadCompleted(file: FileModel): void {
        const url = file.token + '?refresh=' + Guid.create();
        const formControl: UntypedFormControl = new UntypedFormControl(url, Validators.required);
        this.fileUrls.push(formControl);
        this.isUploading = false;
    }

    removeFileItem(fileItem, index: number): void {
        if (fileItem) {
            if (fileItem.remove) {
                fileItem.remove();
            } else {
                fileItem.parentNode.removeChild(fileItem);
            }
            this.fileUrls.removeAt(index);
        }
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            fileUrls: this.formBuilder.array([]),
        });
    }

    ngAfterViewInit(): void {
        this.uploader = this.fileUploadService.fetchFromCache(this.uploaderKey!);
    }
}
